export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const GET_ERRORS = 'GET_ERRORS'

export const GET_PROFILE = 'GET_PROFILE'
export const UPDATE_PROFILE= 'UPDATE_PROFILE'
export const SET_PROFILE_LOADING= 'SET_PROFILE_LOADING'
export const CHARGE_MONEY='CHARGE_MONEY'

export const SET_HOME_STATES_LOADING = "SET_HOME_STATES_LOADING";
export const GET_HOME_STATES = "GET_HOME_STATES";
export const SET_PAGE_PATH = "SET_PAGE_PATH";

export const SET_EXPERTS_SEARCH_LOADING = "SET_EXPERTS_SEARCH_LOADING";
export const GET_EXPERTS_SEARCH = "GET_EXPERTS_SEARCH";

export const GET_PROFILE_INFORMATION = "GET_PROFILE_INFORMATION";
export const EDIT_PROFILE_INFORMATION = "EDIT_PROFILE_INFORMATION";
export const EDIT_PROFILE_INFORMATION_LOADING = "EDIT_PROFILE_INFORMATION_LOADING";

export const TO_BE_EXPERT = "TO_BE_EXPERT";
export const ADMIN_GET_USERS = "ADMIN_GET_USERS";

export const GET_BLOGS = "GET_BLOGS";
export const GET_BLOG_COMMENTS = "GET_BLOG_COMMENTS";

export const ADD_MESSAGE = "ADD_MESSAGE";
export const SET_SOCKET = 'SET_SOCKET';
export const GET_CONVERSATION = "GET_CONVERSATION";

export const GET_USER_ADVICE_MESSAGE = "GET_USER_ADVICE_MESSAGE";
export const ADD_USER_ADVICE_MESSAGE = "ADD_USER_ADVICE_MESSAGE";

export const GET_ADMIN_ADVICE_MESSAGE = "GET_ADMIN_ADVICE_MESSAGE";
export const ADD_ADMIN_ADVICE_MESSAGE = "ADD_ADMIN_ADVICE_MESSAGE";

export const GET_ADVICE_USERS = "GET_ADVICE_USERS";

export const ADMIN_GET_EXPERTS = "ADMIN_GET_EXPERTS";

export const GET_MESSAGES_USERS = "GET_MESSAGES_USERS";
export const ADD_MESSAGES_DATA = "GET_MESSAGES_DATA";
export const GET_MESSAGES_INFORMATION = "GET_MESSAGES_INFORMATION";

export const GET_ORDERS_DATA = "GET_ORDERS_DATA";